import React from 'react'
import {Lang} from 'yougile-lang'
import {GenResp} from 'yougile-model'
import {Refresh} from '@client/refresh'
import {Backend} from '@common/backend'
import {ButtonNew} from '@components/common/base/buttons'
import {showAlert} from '@components/common/base/notifications'
import {globals} from '@extensions/globals-base'
import {ItemContainer} from './item-container'
import {ItemExpired} from './item-expired'
import {
  TwItemTitle,
  TwItemTitleSupport,
  TwTitle,
  TwTitle2,
  TwTitle3
} from './tw'

interface Props {
  waiting: boolean
  setWaiting: (value: boolean) => void
}

export const ActivateOneLicense = ({waiting, setWaiting}: Props) => {
  if (!globals.licenseExpired || waiting) {
    return null
  }

  const getDemoPlatform = () => {
    setWaiting(true)
    Backend.postJSON<GenResp>('/data/request-demo-license-platform', {})
      .then(() => Refresh.refresh())
      .catch(error => showAlert(error))
  }

  return (
    <>
      <div className="flex gap-8 flex-col">
        <TwTitle>{Lang.msg.noLicense.welcomeToYouGile}</TwTitle>
        <TwTitle2>{Lang.msg.noLicense.welcomeToYouGile2}</TwTitle2>
      </div>

      <div className="flex flex-row gap-24 mt-24 mx-auto w-fit items-center">
        <ItemContainer>
          <TwItemTitle>{Lang.msg.noLicense.tariffBox}</TwItemTitle>
          <TwItemTitleSupport>
            {Lang.msg.noLicense.tariffBox1p1}
            <br />
            {Lang.msg.noLicense.tariffBox1p2}
          </TwItemTitleSupport>

          <ItemExpired />

          <TwTitle3 className="mt-20">{Lang.msg.noLicense.tariffBox5}</TwTitle3>

          <ButtonNew
            onMouseDown={getDemoPlatform}
            size="md"
            className="mx-auto w-full mt-8 !py-6"
          >
            <div className="flex flex-col items-center">
              <div className="text-sm-semibold">
                {Lang.msg.noLicense.tariffBox6}
              </div>
              <div className="text-xxxs3-regular">
                {Lang.msg.noLicense.tariffBox7}
              </div>
            </div>
          </ButtonNew>
        </ItemContainer>
      </div>
    </>
  )
}
